import {
	FCM_FUTURE_SAP_MEDIA_DISCLAIMER,
	FCM_PACIFIC_PROMO_FREE_SAMPLE,
	FCM_SAP_AI_IMAGE_PROMPT,
	FCM_STARTER_SAP_AI_PROMPT,
	FCM_STARTER_SAP_PHONE_COLLECTION,
} from '@change-corgi/config/fcm/configs';

import { createFcmContext } from 'src/app/shared/contexts/fcm';
import { FCM_STARFISH_PSF_TO_SAP_LOCAL_FLOW } from 'src/app/shared/fcm/configs';
import type { LoadedStateData } from 'src/app/shared/utils/async';

export const {
	FcmContext: StartAPetitionPageFcmContext,
	FcmProvider: StartAPetitionPageFcmContextProvider,
	useFcm: useStartAPetitionPageFcm,
	useAsyncFcm: useAsyncStartAPetitionPageFcm,
	prefetchFcm: prefetchStartAPetitionPageFcm,
} = createFcmContext({
	name: 'StartAPetitionPageFcmContext',
	dataProperty: 'pageFcm',
	configs: {
		futureSapMediaDisclaimer: FCM_FUTURE_SAP_MEDIA_DISCLAIMER,
		starterSapPhoneCollection: FCM_STARTER_SAP_PHONE_COLLECTION,
		pacificPromoFreeSample: FCM_PACIFIC_PROMO_FREE_SAMPLE,
		starterAIPrompt: FCM_STARTER_SAP_AI_PROMPT,
		sapAIImagePrompt: FCM_SAP_AI_IMAGE_PROMPT,
		psfToSapLocalFlow: FCM_STARFISH_PSF_TO_SAP_LOCAL_FLOW,
	},
	prefetch: true,
});

export type StartAPetitionPageFcmState = ReturnType<typeof useAsyncStartAPetitionPageFcm>;
export type StartAPetitionPageFcm = LoadedStateData<StartAPetitionPageFcmState>;
